import { Flex, Text } from '@chakra-ui/react'
import { FaEye } from 'react-icons/fa'
import { MdArrowRight } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { DescricaoCargo } from '../../../../../interfaces'

interface iProps {
  cargo: DescricaoCargo
}

export const CargoContent: React.FC<iProps> = ({ cargo }) => {
  const nav = useNavigate()

  return (
    <>
      <Flex flexDir={'column'} gap={'.325rem'} fontSize={'14px'}>
        <Text fontSize={'16px'}>
          <strong>Missão</strong>
        </Text>
        {cargo.missao}
      </Flex>

      <Flex flexDir={'column'} gap={'.325rem'} fontSize={'14px'}>
        <Text fontWeight={'bold'} fontSize={'16px'}>Atribuições</Text>
        <Flex flexDir={'column'} gap={'.325rem'} pl={'1rem'} color={'var(--Gray3)'}>
          {Object.entries(cargo.niveis).map(([nivel, conteudo]) => (
            <>
              <Text key={`atribuicao-${nivel}`}>
                <strong>{nivel.includes('_') ? nivel.replaceAll('_', ' ') : nivel}</strong>
              </Text>
              <Flex gap={'.25rem'} pl={'1rem'}>
                {conteudo.atribuicoes.filter(a => a !== '').map(a => {
                  return <>{a.replace('.', '').replaceAll('_', ' ')}; </>
                })}
              </Flex>
            </>
          ))}
        </Flex>
      </Flex>

      <Flex flexDir={'column'} gap={'.325rem'} fontSize={'14px'}>
        <Text fontWeight={'bold'} fontSize={'16px'}>Conhecimentos</Text>
        <Flex flexDir={'column'} gap={'.325rem'} pl={'1rem'} color={'var(--Gray3)'}>
          {Object.entries(cargo.niveis).map(([nivel, conteudo]) => (
            <Flex key={`conhecimento-${nivel}`} flexDir="column" gap=".25rem">
              <Text><strong>{nivel.includes('_') ? nivel.replaceAll('_', ' ') : nivel}</strong></Text>
              <Flex gap={'.25rem'} pl={'1rem'}>
                {conteudo.conhecimentosTecnicos.filter(c => c !== '').map((c) => (
                  <>{c.replace('.', '')}; </>
                ))}
              </Flex>
            </Flex>
          ))}
        </Flex>
      </Flex>

      <Flex flexDir={'column'} gap={'.325rem'} fontSize={'14px'}>
        <Text fontWeight={'bold'} fontSize={'16px'}>Habilidades</Text>
        <Flex flexDir={'column'} gap={'.325rem'} pl={'1rem'} color={'var(--Gray3)'}>
          {Object.entries(cargo.niveis).map(([nivel, conteudo]) => (
            <Flex key={`habilidade-${nivel}`} flexDir="column" gap=".25rem">
              <Text><strong>{nivel.includes('_') ? nivel.replaceAll('_', ' ') : nivel}</strong></Text>
              <Flex gap={'.25rem'} pl={'1rem'}>
                {conteudo.habilidades.filter(h => h !== '').map((h, idx) => (
                  <>{h.replace('.', '')}; </>
                ))}
              </Flex>
            </Flex>
          ))}
        </Flex>
      </Flex>

      <Flex flexDir={'column'} gap={'.325rem'} fontSize={'14px'}>
        <Text fontWeight={'bold'} fontSize={'16px'}>Competências Comportamentais</Text>
        <Flex flexDir={'column'} gap={'.325rem'} pl={'1rem'} color={'var(--Gray3)'}>
          {Object.entries(cargo.niveis).map(([nivel, conteudo]) => (
            <Flex key={`competenciasComportamentais-${nivel}`} flexDir="column" gap=".25rem">
              <Text><strong>{nivel.includes('_') ? nivel.replaceAll('_', ' ') : nivel}</strong></Text>
              <Flex gap={'.25rem'} pl={'1rem'}>
                {conteudo.competenciasComportamentais.filter(c => c !== '').map((c, idx) => (
                  <>{c.replace('.', '')}; </>
                ))}
              </Flex>
            </Flex>
          ))}
        </Flex>
      </Flex>

      <Flex direction="column" gap=".5rem" fontSize="16px">
        <Text fontWeight="bold">Próximos Cargos Possíveis (Trilhas):</Text>
        {cargo.cargosFuturos &&
          Object.entries(cargo.cargosFuturos).map(([trilhaNome, cargos], trilhaIdx) => (
            <Flex key={trilhaIdx} gap=".25rem" fontWeight={400} fontSize={'14px'} alignItems="center" flexWrap="wrap">
              <Text mr=".25rem" color="var(--Gray3)">{trilhaNome}:</Text>
              {cargos.map((cargoNome, idx) => (
                <Flex key={idx} align="center" fontWeight={600} color="var(--Rosa)">
                  {idx > 0 && <MdArrowRight size={18} style={{ margin: '0 4px' }} />}
                  <Text>{cargoNome}</Text>
                </Flex>
              ))}
            </Flex>
          ))}
      </Flex>
      <Flex justifyContent={'end'}>
        <ButtonCmp VarColor='Green2' onClick={() => nav(`/Descritivo/Cargos/${cargo.id}`)} leftIcon={<FaEye/>}>Visualizar detalhes</ButtonCmp>
      </Flex>
    </>
  )
}
